import { render, staticRenderFns } from "./SkeletonCardOutfit.vue?vue&type=template&id=2cec46fa&scoped=true&"
import script from "./SkeletonCardOutfit.vue?vue&type=script&lang=js&"
export * from "./SkeletonCardOutfit.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonCardOutfit.vue?vue&type=style&index=0&id=2cec46fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cec46fa",
  null
  
)

export default component.exports